<script>
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
    import ClientData from "./ClientData";

    export default {
        name: "client-dialog-coordinate-dialog",
        components: {DialogActionbar, DialogBody, DialogHeader, DialogBase, DialogButton},
        props: {
            clientData: ClientData,
            imageSrc: String,
            dotWidth: {
                type: Number,
                default: 16
            }
        },
        data() {
            return {
                showDialog: false,
                xCoordinate: undefined,
                yCoordinate: undefined,

                planImgLoaded: false,
                planImgError: false,

                imgWidth: 0,
                imgHeight: 0,
            }
        },
        computed: {
            translations() {
                return {
                    setVisually: Lang.langGet('Set Visually'),
                    title: Lang.langGet('Set coordinates visually'),
                    failedToLoadPlan: Lang.langGet('Failed to load plan.')
                }
            },
            svgDotStyle() {
                return {
                    left: `${this.imgWidth ? (this.xCoordinate / this.imgWidth * 100) : 0}%`,
                    top: `${this.imgHeight ? (this.yCoordinate / this.imgHeight * 100) : 0}%`,
                    width: `${this.dotWidth}px`
                };
            }
        },
        methods: {
            show() {
                this.showDialog = true;

                this.planImgLoaded = false;
                this.planImgError = false;
            },
            close() {
                this.showDialog = false;
            },
            async handleShowDialog() {
                this.xCoordinate = this.clientData.locationPlanX;
                this.yCoordinate = this.clientData.locationPlanY;

                this.show();

                await this.$nextTick();

                if(this.$refs.locationPlan.naturalWidth) {
                    this.onPlanImgLoad({target: this.$refs.locationPlan});
                }
            },
            updateCoordinates(event) {
                this.xCoordinate = Math.round(event.offsetX / event.target.offsetWidth * this.imgWidth);
                this.yCoordinate = Math.round(event.offsetY / event.target.offsetHeight * this.imgHeight);
            },
            handleSave() {
                this.$emit('save', this.xCoordinate, this.yCoordinate);
                this.close();
            },
            onPlanImgLoad(val) {
                this.planImgLoaded = true;
                this.planImgError = false;

                this.imgWidth = val.target.naturalWidth;
                this.imgHeight = val.target.naturalHeight;
            },
            onPlanImgError() {
                this.planImgLoaded = false;
                this.planImgError = true;
            }
        }
    }
</script>

<template>
    <div>
        <dialog-base
            :showDialog="showDialog"
            @close="close"
        >
            <dialog-header
                :title="translations.title"
                @close="close"
            />
            <dialog-body>
                <div class="d-flex align-center justify-center flex-column py-4 mx-4">
                    <div class="location-dot-container">
                        <img v-if="!planImgError"
                            ref="locationPlan"
                             class="location-image"
                             alt="new location plan"
                             :src="imageSrc"
                             @click.stop.prevent="updateCoordinates"
                             @load="onPlanImgLoad"
                             @error="onPlanImgError"
                        />
                        <div v-else
                             class="py-4">{{ translations.failedToLoadPlan }}
                        </div>
                        <svg v-if="planImgLoaded"
                            xmlns="http://www.w3.org/2000/svg"
                            :style="svgDotStyle"
                            class="location-dot"
                            viewBox="0 0 24 24"
                        >
                            <circle cx="12" cy="12" r="11" fill="#fff"/>
                            <circle cx="12" cy="12" r="7" fill="#f00"/>
                        </svg>
                    </div>
                </div>
            </dialog-body>
            <dialog-actionbar
                @save="handleSave"
                @close="close"
            />
        </dialog-base>
        <dialog-button class="w-100" color="secondary"
            :disabled="!clientData.getLocationPlan()"
            @click="handleShowDialog"
        >
            {{translations.setVisually}}
        </dialog-button>
    </div>
</template>

<style scoped>
    .location-image {
        max-height: 50vh;
        border-radius: 8px;
        cursor: crosshair;
        max-width: 100%;
    }
    .location-dot {
        position: absolute;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }
    .location-dot-container {
        position: relative;
        max-width: 100%;
    }
</style>
